export default __webpack_public_path__ + "static/media/trailer_light.87a6dee0.png";